'use client';

import { SignIn, useUser } from "@stackframe/stack";
import Link from "next/link";
import { useEffect, useRef } from "react";
import { EVT, track } from "@/lib/analytics";

export default function SignInPage() {
  const user = useUser();
  // Fire `login` once when Stack Auth resolves the user on this page —
  // i.e. the moment a sign-in completes (or the user was already logged in
  // and revisited /auth/signin, which we want to count once either way).
  const fired = useRef(false);
  useEffect(() => {
    if (user && !fired.current) {
      fired.current = true;
      track(EVT.LOGIN, { method: 'stack_auth' });
    }
  }, [user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-[#1E4289] mb-2">
            Welcome to RateWDW
          </h1>
          <p className="text-slate-600">
            Sign in to save your ratings and keep scoring WDW
          </p>
        </div>
        <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-8">
          <SignIn />
          <div className="text-center mt-4 pt-4 border-t border-slate-200">
            <Link
              href="/auth/forgot-password"
              className="text-[#1E4289] hover:underline text-sm"
            >
              Forgot your password?
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

